module.exports = __webpack_public_path__ + "static/media/blues20.8358ffc2.png";